import React, { useEffect, useState } from "react";
import { Box, Typography, Rating } from "@mui/material";
import api from "../services/api";
import { useTranslation } from "react-i18next";

const STATS_CATEGORIES = [
  { key: "usability", labelKey: "rating_usability" },
  { key: "taste", labelKey: "rating_taste" },
  { key: "speed", labelKey: "rating_speed" },
  { key: "appearance", labelKey: "rating_appearance" },
  { key: "overall", labelKey: "rating_overall" },
];

const ReviewsStars = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({
    usability: 0,
    taste: 0,
    speed: 0,
    appearance: 0,
    overall: 0,
    count: 0,
  });

  useEffect(() => {
    api.appReviews.stats()
      .then(res => {
        setStats(res.data || {
          usability: 0, taste: 0, speed: 0, appearance: 0, overall: 0, count: 0,
        });
      })
      .catch(() => setStats({
        usability: 0, taste: 0, speed: 0, appearance: 0, overall: 0, count: 0,
      }));
  }, []);

  return (
    <Box sx={{ maxWidth: 400, mx: "auto", my: 4, p: 3, bgcolor: "background.paper", borderRadius: 2, boxShadow: 2 }}>
      <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}>
        {t("user_reviews")}
      </Typography>
      {STATS_CATEGORIES.map(item => (
        <Box key={item.key} sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <Typography sx={{ width: 110 }}>
            {t(item.labelKey)}
          </Typography>
          <Rating value={Number(stats[item.key]) || 0} precision={0.1} readOnly />
          <Typography sx={{ ml: 1 }}>
            {stats[item.key] ? Number(stats[item.key]).toFixed(1) : "-"} / 5
            {stats.count ? ` (${stats.count})` : ""}
          </Typography>
        </Box>
      ))}
      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Typography variant="subtitle1" color="text.secondary">
          {t("total_reviews")}: <b>{stats.count || 0}</b>
        </Typography>
      </Box>
    </Box>
  );
};

export default ReviewsStars;
